<template>
  <div class="flex xs-center mt10">
    <div class="xs-10">
      <div class="xs-center">
        <!-- iterate over icons -->
        <!-- https://github.com/gregoiresgt/payment-icons -->
        <div class="flex xs-center mb2">
          <span>{{ $t("supported-by") }}</span>
        </div>
        
        <div class="flex xs-center">
          <div class="mr1" v-for="icon in icons" :key="icon">
            <img :src="require(`@/assets/img/cards/${icon}.svg`)" class="img-responsive" width="40"/>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/index.css"
export default {
  name: 'payment-icons',
  data () {
    return {
      // visa, mastercard, amex,
      // discover, diners, jcb, union pay
      icons: ['visa', 'mastercard', 'amex']
      
      // icons: ['visa', 'mastercard', 'amex', 'discover', 'diners', 'jcb', 'union']
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/PaymentIcons.vue